import Vue from 'vue'
import Vuex from 'vuex'
import hear from './modules/hear'
import popover from './modules/popover'
import init from './modules/init'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectIndex: 0,
    menuIndex: localStorage.getItem('menuIndex') || null,
    activeIndex: localStorage.getItem('activeIndex') || null,
    showMenusApplicationConfig: JSON.parse(localStorage.getItem('showMenusApplicationConfig')) || {},
    isMenuLoaded: false,
    urlParams: JSON.parse(sessionStorage.getItem('urlParams')) || {}
  },
  getters: {
  },
  mutations: {
    EDITSELECTINDEX: (state,selectIndex) => {
      state.selectIndex = selectIndex
    },
    CHANGESELECTINDEX: (state,selectMenuIndex) => {
      state.menuIndex = selectMenuIndex
      localStorage.setItem('menuIndex',selectMenuIndex)
    },
    ACTIVEINDEX: (state,activeIndex) => {
      state.activeIndex = activeIndex
      localStorage.setItem('activeIndex',activeIndex)
    },
    USERINFO : (state,user_info) => {
      state.user_info = user_info
      localStorage.setItem('user_info',JSON.stringify(user_info))
    },
    APPID : (state,app_id) => {
      state.app_id = app_id
      localStorage.setItem('app_id',JSON.stringify(app_id))
    },
    showMenusApplicationConfig : (state,showMenusApplicationConfig) => {
      state.showMenusApplicationConfig = showMenusApplicationConfig
      localStorage.setItem('showMenusApplicationConfig',JSON.stringify(showMenusApplicationConfig)) 
    },
    isMenuLoaded : (state,isMenuLoaded) => {
      state.isMenuLoaded = isMenuLoaded
    },
    SET_URL_PARAMS: (state, params) => {
      state.urlParams = params
      console.log(params,'.params')
      sessionStorage.setItem('urlParams', JSON.stringify(params))
    }
  },
  actions: {
    editSelectIndex({commit},selectIndex){
      commit('EDITSELECTINDEX',selectIndex)
    },
    changeSelectMenu({commit},selectMenuIndex){
      commit('CHANGESELECTINDEX',selectMenuIndex)
    },
    activeIndex({ commit },activeIndex){
      commit('ACTIVEINDEX', activeIndex)
    },
    saveUserInfo({commit},user_info){
      commit('USERINFO',user_info)
    },
    app_id({commit},app_id){
      commit('APPID',app_id)
    },
    showMenusApplicationConfig({commit},showMenusApplicationConfig){
      commit('showMenusApplicationConfig',showMenusApplicationConfig) 
    },
    isMenuLoaded({commit}){
      commit('isMenuLoaded',true) 
    },
    setUrlParams({commit}, params) {
      console.log(params,'....params')
      commit('SET_URL_PARAMS', params)
    }
  },
  modules: {
    hear,
    popover,
    init
  }
})

